import { exists } from '@/api/runtime'

export interface Alert {
  code: string
  level: AlertLevel
  message: string
  attribute: string
  index: number
  subAttribute: string
}

export const defaultAlert = (): Alert => ({
  code: '',
  level: AlertLevel.Not,
  message: '',
  attribute: '',
  index: 0,
  subAttribute: ''
})

export const AlertLevel = {
  Error: 'ERROR',
  Warn: 'WARN',
  Info: 'INFO',
  Not: '' // 未設定というのは仕様的にはバグという状況
} as const
export type AlertLevel = typeof AlertLevel[keyof typeof AlertLevel]

export function AlertFromJSON(json: any): Alert {
  let attribute = ''
  let index = -1
  let subAttribute = ''

  if (exists(json, 'attribute')) {
    const attributes = json.attribute.split('.')
    attribute = attributes[0]
    if (attributes.length > 1) {
      index = Number(attributes[1])
      if (isNaN(index)) {
        attribute = attributes[0] + '.' + attributes[1]
        if (attributes.length > 2) {
          index = Number(attributes[2])
          subAttribute = attributes[3]
        } else {
          index = -1
        }
      } else {
        subAttribute = attributes[2]
      }
    }
  }

  return {
    code: exists(json, 'code') ? json.code : '',
    level: exists(json, 'level') ? json.level : '',
    message: exists(json, 'message') ? json.message : '',
    attribute,
    index,
    subAttribute: subAttribute ?? ''
  }
}
